/* nl-quiz — a scored one-question-at-a-time quiz with a computed result screen.

   Built for the LX-09 "Packing Check" pre-lander: the scoring and ranking rules are the
   client's package script, ported verbatim (the page's compliance note depends on them:
   the current-setup score always lands 21–44 out of 100 and the soft carry-on always ranks
   first). Everything the reader reads comes from the host section: markup, copy, prices and
   variant ids. This module only moves state and fills slots.

   Root          [data-nl-quiz]                       data-nl-quiz-event-prefix="lx09" (dataLayer event names)
   Config        [data-nl-quiz-config]                <script type="application/json"> inside the root
   Screens       [data-nl-quiz-screen="intro|loading|result"]  and  [data-nl-quiz-screen="question"]
                 with data-nl-quiz-key="trips|length|now|pain|carry" — DOM order is the order of play
   Controls      [data-nl-quiz-start] · [data-nl-quiz-back] · [data-nl-quiz-skip] · [data-nl-quiz-redo]
                 [data-nl-quiz-option data-nl-value="…"] · [data-nl-quiz-reaction] · [data-nl-quiz-check]
                 data-nl-quiz-reactions="value | text" lines on a question screen (shown after an answer)
                 [data-nl-quiz-color data-nl-value] · [data-nl-quiz-model data-nl-value] · [data-nl-quiz-tile data-nl-qty]
                 [data-nl-quiz-go] (every CTA link: href is rebuilt from the chosen colour, model, page query)
   Progress      [data-nl-quiz-progress] · [data-nl-quiz-step] · [data-nl-quiz-fill] · [data-nl-quiz-adnote]
   Sticky        [data-nl-quiz-sticky]
   Slots         [data-nl-slot="name"] filled with text (or a fragment); lists clone a
                 <template data-nl-quiz-template="rank|sub|why"> and fill its slots.
   State classes this module toggles (the host section styles them): nl-is-active (screen),
                 nl-is-on (progress, reaction, sticky bar, sub-score dot), nl-is-selected (option, tile,
                 colour, model), nl-is-done (loading check), nl-has-sticky (root while the result shows).
   Config shape  see the section's `config` capture; every list is a textarea string parsed here:
                 "key | a | b" lines, and "plain *emphasised* plain" for the result headings.

   History       steps push #<n>; Back/Forward work; a loading step maps back to the last question, a
                 result step without a built result maps to the intro.
   Lifecycle     one quiz per page. Re-inits on shopify:section:load, tears down timers and listeners on
                 shopify:section:unload. Reduced motion is a CSS concern (the host section removes the
                 transitions); the loading delay is a deliberate "scoring" pause, not motion. */
(function () {
  var instances = {};

  function lines(str) {
    return String(str || '').split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean);
  }
  /* "key | a | b" → { key: [a, b] } */
  function table(str) {
    var out = {};
    lines(str).forEach(function (l) {
      var p = l.split('|').map(function (x) { return x.trim(); });
      out[p.shift()] = p;
    });
    return out;
  }
  function money(n) { return '$' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }

  function init(root) {
    if (!root || root.__nlQuiz) return;
    var cfgEl = root.querySelector('[data-nl-quiz-config]');
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    var prefix = root.getAttribute('data-nl-quiz-event-prefix') || 'quiz';
    var timers = [];
    var screens = [].slice.call(root.querySelectorAll('[data-nl-quiz-screen]'));
    var qCount = screens.filter(function (s) { return s.getAttribute('data-nl-quiz-screen') === 'question'; }).length;
    var LOADING = qCount + 1, RESULT = qCount + 2;
    var progress = root.querySelector('[data-nl-quiz-progress]');
    var fill = root.querySelector('[data-nl-quiz-fill]');
    var step = root.querySelector('[data-nl-quiz-step]');
    var adnote = root.querySelector('[data-nl-quiz-adnote]');
    var sticky = root.querySelector('[data-nl-quiz-sticky]');
    var cur = 0, A = {}, color = cfg.defaultColor, model = 'Roller', qty = 2, built = false, fee = 0;
    var copy = {
      heads: table(cfg.heads), types: table(cfg.types), feeTexts: table(cfg.feeTexts),
      whyPain: table(cfg.whyPain), whyLength: table(cfg.whyLength), whyCarry: table(cfg.whyCarry),
      ranking: lines(cfg.ranking).map(function (l) { return l.split('|').map(function (x) { return x.trim(); }); }),
      subs: lines(cfg.subLabels), levels: lines(cfg.levels),
    };

    function slot(name) { return root.querySelector('[data-nl-slot="' + name + '"]'); }
    function setText(name, text) { var el = slot(name); if (el) el.textContent = text; }
    function all(sel) { return [].slice.call(root.querySelectorAll(sel)); }
    function on(el, ev, fn) { el.addEventListener(ev, fn); handlers.push([el, ev, fn]); }
    var handlers = [];
    function later(fn, ms) { var t = setTimeout(fn, ms); timers.push(t); return t; }

    /* "plain **bold** plain" with {placeholders} already substituted → fragment */
    function rich(text) {
      var frag = document.createDocumentFragment();
      String(text).split('**').forEach(function (part, i) {
        if (!part) return;
        if (i % 2) { var b = document.createElement('strong'); b.textContent = part; frag.appendChild(b); }
        else frag.appendChild(document.createTextNode(part));
      });
      return frag;
    }
    function subst(tpl, map) { return String(tpl || '').replace(/\{(\w+)\}/g, function (m, k) { return map[k] != null ? map[k] : m; }); }
    function setRich(name, text) { var el = slot(name); if (!el) return; el.textContent = ''; el.appendChild(rich(text)); }
    function setPrice(name, now, was) {
      var el = slot(name); if (!el) return;
      el.textContent = money(now);
      var s = document.createElement('s'); s.textContent = money(was); el.appendChild(s);
    }
    /* heading: "plain *emphasised* plain" → text + <em> */
    function setHeading(name, spec) {
      var el = slot(name); if (!el) return;
      el.textContent = '';
      String(spec || '').split('*').forEach(function (part, i) {
        if (!part) return;
        if (i % 2) { var em = document.createElement('em'); em.textContent = part; el.appendChild(em); }
        else el.appendChild(document.createTextNode(part));
      });
    }
    function track(ev, data) {
      try {
        window.dataLayer = window.dataLayer || [];
        var o = { event: prefix + '_' + ev };
        for (var k in data) o[k] = data[k];
        window.dataLayer.push(o);
      } catch (e) { /* analytics must never break the quiz */ }
    }

    function show(i, push) {
      screens[cur].classList.remove('nl-is-active');
      cur = i;
      screens[cur].classList.add('nl-is-active');
      var isQ = cur >= 1 && cur <= qCount;
      if (progress) progress.classList.toggle('nl-is-on', isQ);
      if (isQ) {
        if (step) { step.textContent = ''; step.appendChild(rich(subst(cfg.stepLabel, { n: cur, total: qCount }))); }
        if (fill) fill.style.width = ((cur - 1) / qCount * 100 + 10) + '%';
      }
      root.classList.toggle('nl-has-sticky', cur === RESULT);
      if (sticky) sticky.classList.toggle('nl-is-on', cur === RESULT);
      if (adnote) adnote.hidden = (cur === 0 || cur === RESULT);
      window.scrollTo(0, 0);
      if (push !== false) { try { history.pushState({ s: cur }, '', '#' + cur); } catch (e) { /* ignore */ } }
      track('step', { step: cur });
    }

    /* ---- scoring: the package's rules, verbatim ---- */
    function scoreIt(trips) {
      var now = A.now || 'sit', pain = A.pain || 'wrinkles', len = A.length || 'week';
      var bases = { check: { room: 4, wr: 2, bin: 1, fee: 1 }, sit: { room: 1, wr: 1, bin: 2, fee: 3 }, gate: { room: 3, wr: 2, bin: 1, fee: 1 }, light: { room: 1, wr: 2, bin: 3, fee: 3 } };
      var base = bases[now] || bases.sit;
      var s = { room: base.room, wr: base.wr, bin: base.bin, fee: base.fee };
      var hit = { wrinkles: 'wr', shoes: 'room', bins: 'bin', heavy: 'bin' }[pain] || 'wr';
      s[hit] = Math.max(1, s[hit] - 1);
      if (trips >= 7) s.fee = Math.max(1, s.fee - 1);
      if ((len === 'week' || len === 'long') && s.room > 1) s.room = s.room - 1;
      var sum = s.room + s.wr + s.bin + s.fee;
      var score = Math.max(21, Math.min(44, Math.round(sum * 4.2 + 6)));
      setText('score', score);
      setText('verdict', score <= 30 ? cfg.verdictLow : cfg.verdictHigh);
      var m = slot('meter');
      if (m) { m.style.width = '0'; later(function () { m.style.width = score + '%'; }, 120); }

      var rows = [[copy.subs[0], s.room], [copy.subs[1], s.wr], [copy.subs[2], s.bin], [copy.subs[3], s.fee]];
      var subs = slot('subs'), tplSub = root.querySelector('[data-nl-quiz-template="sub"]');
      if (subs && tplSub) {
        subs.textContent = '';
        rows.forEach(function (r) {
          var node = tplSub.content.cloneNode(true);
          node.querySelector('[data-nl-slot-in="label"]').textContent = r[0] || '';
          [].forEach.call(node.querySelectorAll('[data-nl-slot-in="dot"]'), function (d, i) { if (i < r[1]) d.classList.add('nl-is-on'); });
          node.querySelector('[data-nl-slot-in="level"]').textContent = copy.levels[r[1] - 1] || '';
          subs.appendChild(node);
        });
      }

      var bp = 58, hs = 52, ck = 40, soft = 96;
      if (len === 'week') bp -= 10;
      if (len === 'long') { bp -= 18; hs -= 6; soft -= 2; }
      if (len === 'weekend') { bp += 4; soft -= 1; }
      if (pain === 'wrinkles') { bp -= 8; hs -= 4; }
      if (pain === 'shoes') { bp -= 6; hs -= 6; }
      if (pain === 'bins') { hs -= 12; }
      if (pain === 'heavy') { hs -= 8; ck -= 6; soft -= 1; }
      if (trips >= 7) { ck -= 12; } else if (trips >= 4) { ck -= 6; }
      if (now === 'sit') hs -= 6;
      if (now === 'gate') hs -= 8;
      if (now === 'check') ck -= 4;
      if (now === 'light') bp -= 6;
      var r0 = copy.ranking;
      var list = [
        [r0[0] && r0[0][0], r0[0] && r0[0][1], soft],
        [r0[1] && r0[1][0], r0[1] && r0[1][1], Math.max(18, Math.min(55, bp))],
        [r0[2] && r0[2][0], r0[2] && r0[2][1], Math.max(18, Math.min(55, hs))],
        [r0[3] && r0[3][0], r0[3] && r0[3][1], Math.max(12, Math.min(55, ck))],
      ];
      var first = list.shift();
      list.sort(function (a, b) { return b[2] - a[2]; });
      list.unshift(first);
      var rank = slot('rank'), tplRank = root.querySelector('[data-nl-quiz-template="rank"]');
      if (rank && tplRank) {
        rank.textContent = '';
        list.forEach(function (x, i) {
          var node = tplRank.content.cloneNode(true);
          node.querySelector('[data-nl-slot-in="n"]').textContent = i + 1;
          node.querySelector('[data-nl-slot-in="name"]').textContent = x[0] || '';
          var best = node.querySelector('[data-nl-slot-in="best"]'); if (best) best.hidden = i !== 0;
          node.querySelector('[data-nl-slot-in="desc"]').textContent = x[1] || '';
          node.querySelector('[data-nl-slot-in="score"]').textContent = x[2];
          rank.appendChild(node);
        });
      }
      track('score', { score: score });
    }

    function buildResult() {
      built = true;
      var trips = parseInt(A.trips || '4', 10);
      fee = trips * cfg.feePerTrip;
      model = (A.carry === 'shoulder') ? 'Classic' : 'Roller';
      setText('fee', subst(cfg.feeSuffix, { fee: money(fee) }));
      var now = A.now || 'sit';
      setText('fee-text', (copy.feeTexts[A.now] || copy.feeTexts.check || [''])[0]);
      setText('math', subst(cfg.feeMath, { trips: trips, perTrip: money(cfg.feePerTrip) }));
      scoreIt(trips);

      var ty = copy.types[A.now] || copy.types.sit || [''];
      setText('type', cfg.typePrefix + ty[0]);

      var firstReview = { wrinkles: 'wrinkles', shoes: 'shoes', bins: 'shoes', heavy: 'long' }[A.pain] || 'shoes';
      if (A.length === 'long') firstReview = 'long';
      var revs = slot('reviews');
      var fr = revs && revs.querySelector('[data-nl-topic="' + firstReview + '"]');
      if (fr) revs.insertBefore(fr, revs.firstChild);

      setRich('limit', A.length === 'long' ? cfg.limitLong : cfg.limitDefault);
      setHeading('head', (copy.heads[now] || copy.heads.sit || [''])[0]);

      var items = [];
      var pain = copy.whyPain[A.pain || 'wrinkles'] || copy.whyPain.wrinkles;
      if (pain) items.push(pain);
      var len = copy.whyLength[A.length || 'week'] || copy.whyLength.week;
      if (len) items.push(len);
      var carry = copy.whyCarry[A.carry || 'both'] || copy.whyCarry.both;
      if (carry) items.push(carry);
      if ((A.now === 'check' || A.now === 'gate') && cfg.whyFees) { var wf = cfg.whyFees.split('|'); items.push([wf[0].trim(), (wf[1] || '').trim()]); }
      var why = slot('why'), tplWhy = root.querySelector('[data-nl-quiz-template="why"]');
      if (why && tplWhy) {
        why.textContent = '';
        items.forEach(function (x) {
          var node = tplWhy.content.cloneNode(true);
          node.querySelector('[data-nl-slot-in="title"]').textContent = x[0] || '';
          node.querySelector('[data-nl-slot-in="text"]').textContent = x[1] || '';
          why.appendChild(node);
        });
      }
      if (cfg.prices[model].two) qty = 2;
      setTile();
      track('result', { trips: trips, length: A.length, now: A.now, pain: A.pain, carry: A.carry, model: model });
      render();
    }

    function render() {
      var key = color + '|' + model, v = cfg.variants[key] || {}, p = cfg.prices[model];
      all('[data-nl-quiz-model]').forEach(function (x) { x.classList.toggle('nl-is-selected', x.getAttribute('data-nl-value') === model); });
      setText('match-why', subst(model === 'Classic' ? cfg.matchWhyClassic : cfg.matchWhyRoller, { two: money(cfg.prices.Classic.two) }));
      setText('match-name', cfg.matchName + ', ' + (cfg.modelNames[model] || model));
      var img = slot('match-img'), ph = slot('match-placeholder');
      if (img) {
        if (v.src) {
          img.src = v.src;
          if (v.srcset) img.setAttribute('srcset', v.srcset); else img.removeAttribute('srcset');
          img.alt = v.alt || '';
          img.hidden = false;
          if (ph) ph.hidden = true;
        } else {
          img.hidden = true;
          if (ph) ph.hidden = false;
        }
      }
      setPrice('p1', p.one, p.oneWas);
      var t2 = root.querySelector('[data-nl-quiz-tile][data-nl-qty="2"]');
      if (p.two) {
        if (t2) t2.hidden = false;
        setPrice('p2', p.two, p.twoWas);
        setText('each', subst(cfg.eachLabel, { each: money(Math.round(p.two / 2)) }));
      } else { if (t2) t2.hidden = true; qty = 1; setTile(); }
      var cost = (qty === 2 && p.two) ? p.two / 2 : p.one;
      var trips = Math.max(1, Math.ceil(cost / cfg.feePerTrip));
      setRich('pay', subst(fee ? cfg.payText : cfg.payTextNoFee, { fee: money(fee), cost: money(Math.round(cost)), trips: trips }));
      setText('sticky-price', qty === 2 && p.two ? subst(cfg.stickyTwo, { price: money(p.two) }) : money(p.one));
      setText('sticky-name', color + ', ' + (cfg.modelNames[model] || model));
      var q = location.search ? '&' + location.search.slice(1) : '';
      var href = cfg.pdp + (v.id ? '?variant=' + v.id + q : (q ? '?' + q.slice(1) : ''));
      all('[data-nl-quiz-go]').forEach(function (a) { a.setAttribute('href', href); });
      setText('go-note', qty === 2 ? cfg.goNoteTwo : cfg.goNoteOne);
    }
    function setTile() {
      all('[data-nl-quiz-tile]').forEach(function (x) { x.classList.toggle('nl-is-selected', parseInt(x.getAttribute('data-nl-qty'), 10) === qty); });
    }

    /* ---- wiring ---- */
    screens.forEach(function (sec) {
      if (sec.getAttribute('data-nl-quiz-screen') !== 'question') return;
      var q = sec.getAttribute('data-nl-quiz-key');
      var reactions = table(sec.getAttribute('data-nl-quiz-reactions'));
      [].forEach.call(sec.querySelectorAll('[data-nl-quiz-option]'), function (b) {
        on(b, 'click', function () {
          [].forEach.call(sec.querySelectorAll('[data-nl-quiz-option]'), function (x) { x.classList.remove('nl-is-selected'); });
          b.classList.add('nl-is-selected');
          A[q] = b.getAttribute('data-nl-value');
          track('answer', { question: q, answer: A[q] });
          var wait = 380, r = sec.querySelector('[data-nl-quiz-reaction]');
          if (r && reactions[A[q]]) { r.textContent = reactions[A[q]][0]; r.classList.add('nl-is-on'); wait = 1500; }
          later(function () { if (cur === qCount) runLoading(); else show(cur + 1); }, wait);
        });
      });
    });
    all('[data-nl-quiz-skip]').forEach(function (b) {
      on(b, 'click', function () { track('skip', { from: cur }); buildResult(); show(RESULT); });
    });
    function runLoading() {
      show(LOADING);
      var lis = all('[data-nl-quiz-check]');
      lis.forEach(function (li) { li.classList.remove('nl-is-done'); });
      [0, 1, 2].forEach(function (k) { later(function () { if (lis[k]) lis[k].classList.add('nl-is-done'); }, 500 + k * 550); });
      later(function () { buildResult(); show(RESULT); }, 2300);
    }
    all('[data-nl-quiz-tile]').forEach(function (t) {
      on(t, 'click', function () { qty = parseInt(t.getAttribute('data-nl-qty'), 10); setTile(); render(); track('tile', { qty: qty }); });
    });
    all('[data-nl-quiz-color]').forEach(function (b) {
      on(b, 'click', function () {
        all('[data-nl-quiz-color]').forEach(function (x) { x.classList.remove('nl-is-selected'); });
        b.classList.add('nl-is-selected'); color = b.getAttribute('data-nl-value'); render(); track('color', { color: color });
      });
    });
    all('[data-nl-quiz-model]').forEach(function (b) {
      on(b, 'click', function () {
        model = b.getAttribute('data-nl-value'); if (cfg.prices[model].two) qty = 2; setTile(); render(); track('model', { model: model });
      });
    });
    all('[data-nl-quiz-go]').forEach(function (a) {
      on(a, 'click', function () { track('cta', { color: color, model: model, qty: qty }); });
    });
    var start = root.querySelector('[data-nl-quiz-start]');
    if (start) on(start, 'click', function () { show(1); });
    var back = root.querySelector('[data-nl-quiz-back]');
    if (back) on(back, 'click', function () { if (cur > 1) show(cur - 1); else show(0); });
    var redo = root.querySelector('[data-nl-quiz-redo]');
    if (redo) on(redo, 'click', function () {
      A = {};
      all('[data-nl-quiz-option]').forEach(function (x) { x.classList.remove('nl-is-selected'); });
      all('[data-nl-quiz-reaction]').forEach(function (x) { x.classList.remove('nl-is-on'); });
      show(1);
    });
    var pop = function (e) {
      var s = (e.state && typeof e.state.s === 'number') ? e.state.s : 0;
      if (s === LOADING) s = qCount;
      if (s === RESULT && !built) s = 0;
      show(s, false);
    };
    window.addEventListener('popstate', pop);
    try { history.replaceState({ s: 0 }, '', '#0'); } catch (e) { /* ignore */ }
    render();

    root.__nlQuiz = true;
    var host = root.closest('[id^="shopify-section-"]');
    instances[host ? host.id : 'x'] = function () {
      timers.forEach(clearTimeout);
      handlers.forEach(function (h) { h[0].removeEventListener(h[1], h[2]); });
      window.removeEventListener('popstate', pop);
      delete root.__nlQuiz;
    };
  }

  function initAll(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-nl-quiz]'), init);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var k = e.target.id || 'x';
    if (instances[k]) { instances[k](); delete instances[k]; }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
})();
